import { useRouter } from 'next/router';

export const useGetUrlPath = () => {
  const router = useRouter();
  return router.asPath;
};
